import { render, staticRenderFns } from "./MarketplacesCategory.vue?vue&type=template&id=6a260f5e&"
import script from "./MarketplacesCategory.vue?vue&type=script&lang=js&"
export * from "./MarketplacesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports